import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import CommonPage from "../../components/common-page";

export default function HighlightsSkeleton() {
  return (
    <CommonPage>
      <Skeleton variant="text" width={240} height={36} />
      <Skeleton variant="text" width={320} height={20} />
      <TableContainer component={Paper} variant="outlined" sx={{ mt: 2 }}>
        <Table size="small">
          <TableBody>
            {[...Array(8)].map((_, i) => (
              <TableRow key={i}>
                <TableCell padding="checkbox">
                  <Skeleton variant="circular" width={20} height={20} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="rounded" width={80} height={20} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width={140} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width={360} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width={50} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width={40} />
                </TableCell>
                <TableCell align="right">
                  <Skeleton variant="rounded" width={70} height={28} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </CommonPage>
  );
}
